import React from "react";
import Multiselect from "multiselect-react-dropdown";

const MultiSelectDropdown = ({
  options,
  selectedValue,
  setSelectedValue,
  name,
}) => {
  const onSelect = (selectedList, selectedItem) => {
    setSelectedValue(selectedList);
  };

  const onRemove = (selectedList, removedItem) => {
    setSelectedValue(selectedList);
  };

  return (
    <div className="multiSelectContainer">
      <Multiselect
        options={options}
        selectedValues={selectedValue}
        onSelect={onSelect}
        onRemove={onRemove}
        showCheckbox={true}
        displayValue="name"
        placeholder={`Select ${name}`}
      />
    </div>
  );
};

export default MultiSelectDropdown;
